import { Component, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SharedService } from '../Services/sharedService';
import { ProjectService } from '../Services/project.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import swal from "sweetalert2";
import { passwordValidator } from '../password-validators';
import { MAT_DIALOG_DATA, matDialogAnimations, MatDialogRef } from '@angular/material/dialog';
import { colors } from '../colors';
import { MessagingServiceService } from '../Services/messaging-service.service';
import { AuthService } from '../Services/auth.service';

@Component({
    selector: 'app-new-password',
    templateUrl: './new-password.component.html',
    styleUrls: ['./new-password.component.css'],
    standalone: false
})
export class NewPasswordComponent {


  resetPasswordForm: UntypedFormGroup;
  hide = true;
  hideConfirm: boolean = true;
  email = '';
  code = '';
  isDisable = false;
  isEmployee: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public user: any, private dialogRef: MatDialogRef<any>, private _sharedServices: SharedService, private _projectService: ProjectService, private _snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute,
    private _messagingService: MessagingServiceService,
    private authService: AuthService
  ) {
    // Prefer dialog payload: admin "Reset Password" always passes { id, email }.
    // URL-only detection misses some employee screens and wrongly calls bdpwr (rest_no_route).
    // Upstream: strip query string before path compares.
    const basePath = router.url.split('?')[0];
    this.isEmployee = !!(user?.id) ||
      basePath === '/employees' ||
      basePath === '/projects' ||
      router.url.includes('user-details/');
    console.log("is employee: ", this.isEmployee)
    if (!this.isEmployee)
      this._sharedServices.sideMenuSubject.next(false);
    this.route.queryParams.subscribe(params => {
      if (params['data']) {
        let data = JSON.parse(params['data'])
        this.email = data.email;
        this.code = data.code;
      }
    });
    this.resetPasswordForm = new UntypedFormGroup({
      password: new UntypedFormControl("", [Validators.required, Validators.minLength(8), Validators.maxLength(20), passwordValidator()]),
      confirmPassword: new UntypedFormControl("", [Validators.required]),
    }, { validators: this.passwordMatchValidator });

    if (this.isEmployee) {
      this.resetPasswordForm.addControl('email', new UntypedFormControl({ value: user.email, disabled: true }))
    }
  }

  passwordMatchValidator(form: UntypedFormGroup) {
    return form.get('password').value === form.get('confirmPassword').value ? null : { 'mismatch': true };
  }

  resetPassAction() {
    this.isDisable = true;

    if (!this.resetPasswordForm.valid || this.resetPasswordForm.get('password').value !=
      this.resetPasswordForm.get('confirmPassword').value) {
      this.isDisable = false;
      return
    } else {
      this
        ._projectService
        .resetPasword(this.resetPasswordForm.value.password, this.email, this.code).subscribe((user: any) => {
          swal.fire({
            icon: 'success',
            title: 'Password updated',
            text: 'Sign in with your new password.',
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            this.router.navigate(["/reset-sucessfully"]).then(() => {
              // this.authService.performLogout();
            });
          });
          this.isDisable = false;
        }, err => {
          this.isDisable = false;
          this._snackBar.open("Couldn't update your password. Try again.", 'Close', {
            duration: 8000
          })
        })
    }
  }

  resetUserPassword() {
    this.isDisable = true;
    if (!this.resetPasswordForm.valid || this.resetPasswordForm.get('password').value !=
      this.resetPasswordForm.get('confirmPassword').value) {
      this.isDisable = false;
      return
    }
    else {
      this.dialogRef.close();
      swal.fire({
        title: "Reset this employee's password?",
        html: '<p>If they are signed in, they will be signed out.</p>' +
          '<div class="ss-impact"><strong>Important</strong>Their current password will stop working. They need the new password to sign in.</div>',
        showCancelButton: true,
        confirmButtonText: 'Reset password',
        confirmButtonColor: colors.purple,
        cancelButtonColor: '#6c757d',
        cancelButtonText: 'Keep current password',
        reverseButtons: true,
      }).then((result) => {
        console.log("User: ", this.user, result)
        if (result.isConfirmed) {
          this.user['password'] = this.resetPasswordForm.get('password').value
          console.log("this.user submitting form: ", this.user)

          this._projectService.resetUserPassword(this.user).subscribe((res) => {
            swal.fire({
              icon: 'success',
              title: 'Password reset',
              text: 'They need the new password to sign in.',
              confirmButtonText: 'Done',
            })
            this.dialogRef.close();
            // this.authService.performLogout();
          }, err => {
            this.isDisable = false;
            this._snackBar.open("Couldn't reset the password. Try again.", 'Close', {
              duration: 8000
            })
          })
        }
      });
    }
  }

  closeModal() {
    this.dialogRef.close()
  }
}
